export enum EnumAmbiente {
    Sandbox = 0,
    Homologacao = 1,
    Producao = 2,
}